/* eslint-disable */
import { Manifest, RemoteConfig } from '@angular-architects/module-federation';
import { extractValue, loadConfigurationWithFallback } from './configuration-api-call';
import { environment } from './environments/environment';

export async function fetchManifest(): Promise<Manifest> {
    const result = await loadConfigurationWithFallback('root_manifest', './assets/manifest/mfe.manifest.json');

    if (!result.ok) {
        throw Error('could not load configFile root_manifest from: ' + result.url);
    }

    return parseConfig(await result.json().then(extractValue));
}

export function overrideRemote(config: any): Manifest {
    if (!environment.development) {
        return config;
    }

    const overrideString = localStorage.getItem('manifest_override');
    if (!overrideString) {
        return config;
    }

    const override = config;
    const overrideMap: Record<string, OverrideEntry> = JSON.parse(overrideString);

    const keys = Object.keys(overrideMap);
    keys.forEach((remote) => {
        override[remote].remoteEntry = overrideMap[remote].remoteEntry;
        override[remote].remoteConfig = overrideMap[remote].remoteConfig;
    });

    return override;
}

function parseConfig(config: any): Manifest {
    const result: Manifest = {};
    for (const key in config) {
        const value = config[key];
        let entry: RemoteConfig;
        if (typeof value === 'string') {
            entry = {
                remoteEntry: value,
                type: 'module'
            };
        } else {
            entry = {
                ...value,
                type: value.type || 'module'
            };
        }

        result[key] = entry;
    }
    return result;
}

interface OverrideEntry {
    remoteEntry: string;
    remoteConfig: string;
}

/**
 * Override example object
 *
 */
const overrideExample: Record<string, OverrideEntry> = {
    '@eng-neta/cer': {
        remoteEntry: 'https://localhost:4203/remoteEntry.js',
        remoteConfig: 'https://localhost:4203/assets/config.json'
    },
    '@eng-neta/auth': {
        remoteEntry: 'http://localhost:4202/remoteEntry.js',
        remoteConfig: 'http://localhost:4202/assets/config.json'
    }
};
